import { render } from "./HeaderFontPicker.vue?vue&type=template&id=de984f9e"
import script from "./HeaderFontPicker.vue?vue&type=script&lang=js"
export * from "./HeaderFontPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__